import { Target } from "@org-avp/avp-avengers-tmm-service-api";

export const stringifyTarget = (colorFamilyEnabled: boolean, target: Target) => {
  return colorFamilyEnabled
    ? `${target.group}_${target.colorFamily ?? ""}_${target.zone}___${target.colorFamilyDescription ?? ""}`
    : `${target.group}_${target.grainCode ?? ""}${target.colorCode ?? ""}_${target.zone}${target.index ?? ""}`;
};
